import PropTypes from 'prop-types';
import React from 'react'
import ReactDOM from 'react-dom'


export default class extends React.Component {
    static propTypes = {
		children: PropTypes.oneOfType([
			PropTypes.object,
			PropTypes.string
		]),
		type: PropTypes.string,
		className: PropTypes.string
	};

    state = {
        needsOverflow: true,
        open: false
    };

    componentDidMount() {
		this.setState({
			needsOverflow: this.needsOverflow()
		})
	}

    needsOverflow = () => {
		let dom = ReactDOM.findDOMNode(this.refs.text);
		let bounding = dom.getBoundingClientRect(),
			height = bounding.height,
			requiredHeight = this.type === 'reply' ? 150 : 200;
		return height > requiredHeight;
	};

    toggleText = () => {
		this.setState({
			open: !this.state.open
		})
	};

    render() {

		let style = this.state.open || !this.state.needsOverflow ? {maxHeight: '100%'} : {};

		return (
			<div className={"overflow-text " + this.props.type} style={style}>
				<p className={this.props.className} ref="text">
					{this.props.children}
				</p>
				{ !!this.state.needsOverflow && (
					!this.state.open
						? <div className="fade-out-vertical clickable" onClick={this.toggleText}>
							<p className="open-bar text-center mbot10">
								<i className="icon-arrow-down"></i>
							</p>
						</div>
						: <p className="close-bar text-center mbot10 clickable" onClick={this.toggleText}>
							<i className="icon-arrow-up"></i>
						</p>
				) }
				<div className="clearfix"></div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/MainFeeds/ContentParts/OverflowText.jsx